<template lang="pug">
  .LocationEditor
    ValidationObserver(v-slot="{ invalid, validated, passes, validate, errors }")
      v-form
        v-row(no-gutters)
          v-col(cols="12")
            ValidationProvider(name="Nome attività" rules="required" v-slot="{ errors }")
              v-text-field(
                v-model="location.name" required
                name="nome" type="text"
                :error-messages="errors"
                label="Nome attività *" prepend-icon="mdi-sign-text"
              )
          v-col(cols="12")
            ValidationProvider(name="Categoria" rules="required" v-slot="{ errors }")
              v-select(
                v-model="location.mainCategory"
                :items="categories"
                item-text="description"
                item-value="name"
                :error-messages="errors"
                label="Categoria *"
                prepend-icon="mdi-shape-outline"
              )
          v-col(cols="12")
            ValidationProvider(name="Sottocategorie" rules="required" v-slot="{ errors }")
              v-select(
                v-model="location.categories"
                multiple
                :items="subcategories"
                item-text="description"
                item-value="name"
                :error-messages="errors"
                label="Sottocategorie *"
                prepend-icon="mdi-shape-outline"
              )
          v-col(cols="12")
            ValidationProvider(name="Descrizione" v-slot="{ errors }")
              v-textarea(
                v-model="location.description"
                :error-messages="errors"
                label="Descrizione"
                prepend-icon="mdi-text"
                hint="Descrivi il tuo locale"
              )
          v-col(cols="12")
            v-expansion-panels.OpeningHours(accordion flat)
              v-expansion-panel
                v-expansion-panel-header.pa-0
                  div
                    v-icon(left) mdi-clock-outline
                    | Orario di apertura
                v-expansion-panel-content(eager)
                  div(v-for="i in [0,1,2,3,4,5,6]" :key="i")
                    .d-flex.align-center
                      .flex-grow-1.subtitle-1 {{ days[location.openingHours[i].weekday] }}
                      div
                        v-checkbox(
                          v-model="location.openingHours[i].closed"
                          :value="location.openingHours[i].closed"
                          name="chiuso"
                          label="Chiuso",
                          @change="v => changeCheckbox(i, v)"
                        )
                    div(v-if="!location.openingHours[i].closed")
                      SlotsTimePicker(:timeSlots="location.openingHours[i].slots")
          v-col(cols="12")
            ValidationProvider(name="Immagine di Copertina" ref="fileProvider" rules="required_if_not:coverImage|image|size:20480" v-slot="{ validate, errors }")
              v-file-input(
                label="Immagine di Copertina *"
                prepend-icon="mdi-camera"
                @change="handleFile"
                :error-messages="errors"
                accept="image/*"
                v-model="location.imageFile"
              )
          v-col(cols="12" v-if="location.coverImage")
            .text-center
              img(:src="location.coverImage" style="max-width:100%; max-height: 300px")
            ValidationProvider(rules="" vid="coverImage")
              input(type="hidden" v-model="location.coverImage")
          v-col(cols="12")
            .subtitle-1 Luogo
          v-col(cols="12")
            ValidationProvider(name="Indirizzo" rules="required" v-slot="{ errors }")
              v-text-field(
                v-model="location.address" required
                name="indirizzo" type="text"
                :error-messages="errors"
                label="Indirizzo *" prepend-icon="mdi-map-marker"
              )
          v-col(cols="12")
            ValidationProvider(name="Citta'" rules="required" v-slot="{ errors }")
              v-text-field(
                v-model="location.city" required
                name="citta'" type="text"
                :error-messages="errors"
                label="Citta' *" prepend-icon="mdi-map-marker"
              )
          v-col(cols="6")
            ValidationProvider(name="CAP" rules="required" v-slot="{ errors }")
              v-text-field(
                v-model="location.zipCode" required
                name="cap" type="text"
                :error-messages="errors"
                label="CAP *" prepend-icon="mdi-map-marker"
              )
          v-col.pl-3(cols="6")
            ValidationProvider(name="Provincia" rules="required|max:2|min:2" v-slot="{ errors }")
              v-text-field(
                v-model="location.province" required
                name="provincia" type="text"
                :error-messages="errors"
                label="Provincia *"
              )
          v-col(cols="12")
            .subtitle-1 Contatti
          v-col(cols="12")
            ValidationProvider(name="Telefono" v-slot="{ errors }")
              v-text-field(
                v-model="location.phone"
                name="telefono" type="text"
                :error-messages="errors"
                label="Telefono" prepend-icon="mdi-phone"
              )
          v-col(cols="12")
            ValidationProvider(name="Email" rules="email" v-slot="{ errors }")
              v-text-field(
                v-model="location.email"
                name="email" type="text"
                :error-messages="errors"
                label="Email" prepend-icon="mdi-at"
              )
          v-col(cols="12")
            ValidationProvider(name="Numero Whatsapp" rules="" v-slot="{ errors }")
              v-text-field(
                v-model="location.whatsapp"
                name="email" type="text"
                :error-messages="errors"
                label="Numero WhatsApp" prepend-icon="mdi-whatsapp"
                hint="Senza prefisso +39"
              )
          v-col(cols="12")
            ValidationProvider(name="Sito" rules="" v-slot="{ errors }")
              v-text-field(
                v-model="location.website"
                name="sito" type="text"
                :error-messages="errors"
                label="Sito" prepend-icon="mdi-web"
                hint="Ad esempio www.tuosito.it"
              )
          v-col.d-inline-flex.mt-3(cols="12")
            v-spacer
            v-btn.primary(
              @click="passes(save)"
              :disabled='invalid'
              :loading='saving'
            ) Salva
          template(v-if="Object.keys(getErrors(errors)).length")
            v-col.mt-3(cols="12")
              v-expansion-panels(accordion flat)
                v-expansion-panel
                  v-expansion-panel-header.pa-0
                    div
                      v-btn.error Vedi Errori Form
                  v-expansion-panel-content.mx-n3
                    v-list
                      v-list-item.pa-0(v-for="error, key in getErrors(errors)" :key="key")
                        div
                          b {{ key }}
                          | : {{ error }}


</template>

<script>
import SlotsTimePicker from "@/components/SlotsTimePicker";

function toBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) resolve(null);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: "LocationEditor",
  components: { SlotsTimePicker },
  props: {
    location: {
      type: Object,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      days: [
        "Domenica",
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato"
      ]
    };
  },
  computed: {
    subcategories: function() {
      if (!this.location.mainCategory) return [];
      console.log(this.location.mainCategory);
      console.log(this.categories);
      return (
        this.categories.find(c => c.name == this.location.mainCategory)
          .categories || []
      );
    }
  },
  created() {
    if (location.openingHours)
      for (const openingHour of location.openingHours) {
        if (!openingHour.slots || openingHour.slots.length == 0)
          openingHour.closed = true;
      }
  },
  methods: {
    getErrors(errors) {
      const realErrors = {};
      for (const key in errors) {
        if (errors[key] && errors[key].length > 0) {
          realErrors[key] = errors[key][0];
        }
      }
      return realErrors;
    },

    async handleFile(e) {
      const { valid } = await this.$refs.fileProvider.validate(e);
      if (valid) {
        this.location.coverImage = await toBase64(this.location.imageFile);
      }
    },

    async changeCheckbox(i, closed) {
      this.$set(this.location.openingHours, i, {
        ...this.location.openingHours[i]
      });
      if (!closed) {
        while (this.location.openingHours[i].slots.length < 2) {
          this.location.openingHours[i].slots.push({ from: null, to: null });
        }
      }
      this.$forceUpdate();
    },

    save() {
      const newLocation = JSON.parse(JSON.stringify(this.location));
      // handle open/closed
      for (const openingHour of newLocation.openingHours) {
        if (openingHour.closed) {
          openingHour.slots = [];
        } else {
          openingHour.slots = openingHour.slots.filter(s => s.from && s.to);
        }
      }
      // handle openingHours not present, then don't send time
      if (
        newLocation.openingHours.some(o => o.slots.length == 0 && !o.closed)
      ) {
        newLocation.openingHours = null;
      }
      newLocation.nation = "IT";
      this.$emit("save", newLocation);
    }
  }
};
</script>

<style lang="scss">
.OpeningHours {
  .v-expansion-panel-content__wrap {
    padding: 0.5rem !important;
  }

  .v-input--checkbox {
    margin-top: 0;

    .v-messages {
      display: none;
    }
  }
}
</style>
